export default __webpack_public_path__ + "05100ddd699dd53a9955ccfef8a4ac70.jpeg";